import React, { Component } from 'react';

import cx from 'classnames';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { UiActions } from 'state/actions/UiActions';
import { FileActions } from 'state/actions/user/FileActions';
import { Link } from 'react-router-dom';
import { CopyToClipBoard } from '../../../utils/CopyToClipBoard';
import { PrimaryPinkButton } from 'components/buttons/PrimaryPinkButton';

import fadas1Img from '../../../assets/img/signatures/fadas-s1.png';
import fadas2Img from '../../../assets/img/signatures/fadas-s2.png';
import promotionWeekImg from '../../../assets/img/signatures/promo-da-semana.jpg';

import { Utils } from '../../../utils/Utils';

import starIconImg from '../../../assets/svg/star.svg';

import Styles from './styles.module.scss';

class DivulgacaoGlambox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cupomMensal: null,
      cupomSemestral: null,
      cupomAnual: null,

      planoMensal: null,
      planoSemestral: null,
      planoAnual: null,
      person: this.props.person.person,
    };

    this.postImageRef = React.createRef();
    this.postMidImage = React.createRef();
    // this.postVideoRef = React.createRef();
    this.postSecondImageRef = React.createRef();
  }

  copyCouponToClipboard = (id, props) => {
    CopyToClipBoard.copyToClipBoard(id, props);
  };

  handleSavePost = (src, filename) => {
    if (!src || src?.trim() === '') {
      return;
    }
    Utils.downloadImage(src, filename);
  };

  componentDidMount() {
    this._glampartnerCouponCheck();
  }

  _glampartnerCouponCheck = () => {
    let promos = [
      {
        subscriptionTypeId: 1,
        couponName: 'GP_AQ_Mensal',
        isRenewal: false,
      },
      {
        subscriptionTypeId: 3,
        couponName: 'GP_AQ_Semestral',
        isRenewal: false,
      },
      {
        subscriptionTypeId: 2,
        couponName: 'GP_AQ_Anual',
        isRenewal: false,
      },
    ];

    const { person, partnerInfo } = this.props;

    for (let n = 0; n < promos.length; n++) {
      let curr = promos[n];

      ExecuteRequest(
        GlamboxEndpoints.Coupon.check,
        Object.assign({}, curr, {
          personId: person.person.id,
          subscriberId: partnerInfo.subscriberId,
          subscriptionId: 1,
        }),
        'POST',
        {
          Authorization: this.props.token.Authorization,
        },
        null,
        response => {
          let { result, statusCode } = response;

          if (statusCode === 200) {
            if (result.coupon.isGlampartner) {
              let state = {};

              // eslint-disable-next-line default-case
              switch (result.coupon.subscriptionTypeRestriction) {
                case 1:
                  state.cupomMensal = {
                    value: 12,
                    // value: result.coupon.value ?? 0,
                    // renderedValue: Utils.toCurrency(result.coupon.value)
                    renderedValue: result.coupon.freebieMessage,
                  };
                  break;
                case 2:
                  state.cupomAnual = {
                    value: 12,
                    // value: result.coupon.value ?? 0,
                    // renderedValue: Utils.toCurrency(result.coupon.value)
                    renderedValue: result.coupon.freebieMessage,
                  };
                  break;
                case 3:
                  state.cupomSemestral = {
                    // value: result.coupon.value ?? 0,
                    value: 12,
                    // renderedValue: Utils.toCurrency(result.coupon.value)
                    renderedValue: result.coupon.freebieMessage,
                  };
                  break;
              }

              this.setState(state, () => {
                this.forceUpdate();
              });
            }
          }

          this.getGlampartnerSubscriptionType();
        }
      );
    }
  };

  getGlampartnerSubscriptionType = async () => {
    const response = await ExecuteRequest(
      GlamboxEndpoints.Open.subscriptionList,
      null,
      'GET',
      null,
      {
        id: 1,
      }
    );

    const priceCalculationByPlan = plano => {
      let fullValue = 0;
      let discountedAmount = 0;

      switch (plano.name) {
        case 'Anual':
          fullValue = plano.price / 12;
          // discountedAmount = fullValue - this.state.cupomAnual.value / 12;
          // discountedAmount = fullValue * this.state.cupomAnual.value / 100;
          discountedAmount =
            // fullValue - (fullValue * this.state.cupomAnual.value) / 120;
            fullValue - (fullValue * this.state.cupomAnual.value / 100);
          break;

        case 'Semestral':
          fullValue = plano.price / 6;
          // discountedAmount = fullValue - this.state.cupomAnual.value / 6;
          // discountedAmount = fullValue * this.state.cupomSemestral.value / 100;
          discountedAmount =
            // fullValue - (fullValue * this.state.cupomSemestral.value) / 120;
            fullValue - (fullValue * this.state.cupomSemestral.value / 100);
          break;

        case 'Mensal':
          fullValue = plano.price;
          // discountedAmount = fullValue - this.state.cupomAnual.value / 1;
          // discountedAmount = fullValue * this.state.cupomMensal.value / 100;
          discountedAmount =
            // fullValue - (fullValue * this.state.cupomMensal.value) / 120;
            fullValue - (fullValue * this.state.cupomMensal.value / 100);
          break;

        default:
          break;
      }

      return { fullValue, discountedAmount };
    };

    const planos = response.result.map(plano => {
      return {
        name: plano.name,
        price: plano.price,
        fullValue: priceCalculationByPlan(plano)?.fullValue ?? 0,
        discountedAmount: priceCalculationByPlan(plano)?.discountedAmount ?? 0,
      };
    });

    this.setState({
      ...this.state,
      planoMensal: planos.find(plano => plano.name === 'Mensal'),
      planoSemestral: planos.find(plano => plano.name === 'Semestral'),
      planoAnual: planos.find(plano => plano.name === 'Anual'),
    });
  };

  // --------------------------------------------------------------------

  render() {
    return (
      <div id={Styles['divulgacao-glambox']}>
        <Helmet>
          <title>Portal Glampartners: Assinatura</title>
        </Helmet>

        {/* PROMOS DO CUPOM */}
        <div id={Styles['section-signatures']}>
          <div className={Styles['container']}>
            <h1>Assinaturas</h1>
            <p>
              Somos muito mais que um clube de assinatura, somos um clube de
              beleza! Nossas Glamgirls recebem todo mês +R$220 em produtos de
              acordo com o perfil de beleza e acessam um universo de benefícios
              como descontos em produtos na Glamshop e muito conteúdo exclusivo.
            </p>
            <strong>
              Venha divulgar o seu cupom para suas seguidoras fazerem parte
              desse universo também.
            </strong>
          </div>
        </div>

        <div id={Styles['section-coupon']}>
          <h1>Divulgue seu cupom</h1>
          <p>e ganhe comissão</p>
          <div className={Styles['coupon-group']}>
            <div className={Styles['coupon']}>
              <span id="user-cupon">{this.state.person?.couponName}</span>
              <PrimaryPinkButton
                type="button"
                onClick={() =>
                  this.copyCouponToClipboard('user-cupon', this.props)
                }
              >
                Copiar
              </PrimaryPinkButton>
            </div>
            <div className={Styles['coupon']}>
              <span className={Styles['small-text']} id="link-coupon">
                {`https://glambox.com.br/promocoes/assinaturas?cupom=${this.state.person?.couponName}`}
              </span>
              <PrimaryPinkButton
                type="button"
                onClick={() =>
                  this.copyCouponToClipboard('link-coupon', this.props)
                }
              >
                Copiar
              </PrimaryPinkButton>
            </div>
          </div>
        </div>

        <div id={Styles['section-commissions']}>
          <div className={Styles['container']}>
            <h1>Comissões</h1>
            <p>
              Ao trazer novas assinantes para o clube{' '}
              <strong>você ganha</strong> comissões de acordo com cada plano
              vendido.
            </p>
            <div className={Styles['plans-content']}>
              <span className={Styles['plan']}>
                Mensal
                <strong>R$ 15,00*</strong>
              </span>
              <span className={Styles['plan']}>
                Semestral
                <strong>R$ 40,00*</strong>
                <small>* por plano vendido</small>
              </span>
              <span className={Styles['plan']}>
                Anual
                <strong>R$ 60,00*</strong>
              </span>
            </div>

            <span className={Styles['about-payments']}>
              <Link to="/glampartner/resultados">Clique aqui</Link> e saiba mais
              sobre os pagamentos.
            </span>
          </div>
        </div>

        {/* PROMOCAO DA SEMANA */}
        <div id={Styles['section-week-promotion']}>
          <div className={Styles['container']}>
            <h1>Promoção da Semana</h1>
            <p>
              Suas seguidoras também ganham!
              <br />
              <strong>
                Confira abaixo o que o seu cupom oferece em cada plano.
              </strong>
            </p>

            <div className={Styles['cards-group']}>
              <div className={Styles['cards-divider']}>
                <div className={cx(Styles['card'], Styles['semester-card'])}>
                  <h4>Plano Semestral</h4>
                  <strong>{this.state.cupomSemestral?.value ?? 0}% OFF</strong>
                  <small>
                    de{' '}
                    <span>
                      <s>
                        {Utils.toCurrency(this.state.planoSemestral?.fullValue)}
                      </s>
                    </span>{' '}
                    por apenas{' '}
                    <span>
                      {Utils.toCurrency(
                        this.state.planoSemestral?.discountedAmount
                      )}
                      /mês
                    </span>
                  </small>
                </div>

                <div className={cx(Styles['card'], Styles['yearly-card'])}>
                  <div className={Styles['card-header']}>
                    <div className={Styles['icon']}>
                      <img src={starIconImg} alt="Plano Anual" />
                    </div>
                    <h4>Plano Anual</h4>
                  </div>
                  <strong>{this.state.cupomAnual?.value ?? 0}% OFF</strong>
                  <small>
                    de{' '}
                    <span>
                      <s>
                        {Utils.toCurrency(this.state.planoAnual?.fullValue)}
                      </s>
                    </span>{' '}
                    por apenas{' '}
                    <span>
                      {Utils.toCurrency(
                        this.state.planoAnual?.discountedAmount
                      )}
                      /mês
                    </span>
                  </small>
                  <div className={Styles['product']}>
                    <img
                      className={Styles['gp-gift']}
                      src="https://storage.googleapis.com/b4astage-cb80a.appspot.com/glambox/assets/images/landing-pages/invite/banner/Foto-brinde-portal-2-(Promocional---Box_-Bag-e-Pass-2).png"
                      alt="+ Glambag de brinde!"
                    />
                    <span>+ Glambag de brinde!</span>
                  </div>
                </div>
              </div>

              <div className={cx(Styles['card'], Styles['monthly-card'])}>
                <h4>Plano Mensal</h4>
                <strong>{this.state.cupomMensal?.value ?? 0}% OFF</strong>
                <small>
                  de{' '}
                  <span>
                    <s>{Utils.toCurrency(this.state.planoMensal?.fullValue)}</s>
                  </span>{' '}
                  por apenas{' '}
                  <span>
                    {Utils.toCurrency(this.state.planoMensal?.discountedAmount)}
                    /mês
                  </span>
                </small>
              </div>
            </div>

            <span className={Styles['friend-tip']}>
              <strong>Dica de amiga:</strong> O plano anual é o mais em conta! A
              parcela mensal é a mais barata e ainda ganha um brinde! ;)
            </span>
          </div>
        </div>

        {/* POSTAGENS */}
        <div id={Styles['section-post']}>
          <div className={Styles['container']}>
            <h1>Postagens</h1>
            <p>
              Para dar aquela forcinha, separamos alguns materiais para usar na
              sua divulgação! A dica é nunca esquecer de usar o seu link
              compartilhado no “arrasta pra cima” dos stories e caprichar muito
              no conteúdo. Boa sorte!
            </p>
          </div>
          <div className={Styles['post-cards-group']}>
            <div className={Styles['post-card']}>
              <img src={fadas1Img} alt="" ref={this.postImageRef} />
              <div>
                <span>Fadas</span>
                <PrimaryPinkButton
                  onClick={() =>
                    this.handleSavePost(
                      this.postImageRef?.current?.src,
                      'Glambox Fadas'
                    )
                  }
                >
                  Salvar Imagem
                </PrimaryPinkButton>
              </div>
            </div>
            <div className={Styles['post-card']}>
              <img src={fadas2Img} alt="" ref={this.postMidImage} />
              {/* <video loop autoPlay muted>
                <source
                  src={require('assets/img/glampartner/glambox-wild-video.mp4')}
                  type="video/mp4"
                  ref={this.postVideoRef}
                />
              </video> */}
              <div>
                <span>Fadas</span>
                <PrimaryPinkButton
                  onClick={() =>
                    this.handleSavePost(
                      this.postMidImage?.current?.src,
                      'Glambag Fadas'
                    )
                  }
                >
                  Salvar Imagem
                </PrimaryPinkButton>
              </div>
            </div>
            <div className={Styles['post-card']}>
              <img
                src={promotionWeekImg}
                ref={this.postSecondImageRef}
                alt="imagem para download"
              />
              <div>
                <span>Fadas</span>
                <PrimaryPinkButton
                  onClick={() =>
                    this.handleSavePost(
                      this.postSecondImageRef?.current?.src,
                      'Promo da semana'
                    )
                  }
                >
                  Salvar Imagem
                </PrimaryPinkButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  person: state.person.data,
  partnerInfo: state.partnerInfo,
  token: state.token.data,
});

const mapDispatchToProps = dispatch => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  uploadFile: (file, callback) => {
    dispatch(FileActions.upload(file, callback));
  },
});

DivulgacaoGlambox = connect(
  mapStateToProps,
  mapDispatchToProps
)(DivulgacaoGlambox);

export { DivulgacaoGlambox };
